module.exports = __webpack_public_path__ + "img/banner_common.615cf032.png";